module.exports = __webpack_public_path__ + "static/img/GettyImages-645425977.0f14a4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/GettyImages-645425977.jpg
// module id = dbb2
// module chunks = 0